import React from 'react';
import Modal from '../shared/Modal';
import Formsy from 'formsy-react';
import SimpleInput from '../form/SimpleInput';
import FormsySimpleInput from '../form/FormsySimpleInput';
import FormSelect from '../form/Select';
import { menuAPI } from '../../InterfaceAPI/menuAPI';
import { maskMoney } from '../../masks';
import { dollarsToCents } from '../../helpers/util';

class ProductPricingModal extends React.Component {
  state = {
    totalPrice: 0,
    price: 0,
    unit: {},
    grams: 0,
    availableUnits: [],
    unitOptions: []
  };

  render() {
    const { isOpen, closeModal } = this.props;
    const { totalPrice, price, unit, grams, unitOptions } = this.state;
    const { handleChange, handleSelectChange, handleSubmit } = this;

    return (
      <Modal isOpen={isOpen} onRequestClose={closeModal}>
        <div className='admin-wrapper'>
          <h2 className="h2 modal__heading">Pricing</h2>
          <Formsy className="form" onValidSubmit={handleSubmit}>
            <div className="form__row">
              <div className="form__row-item--half">
                <p className="simple-input__label">Product Price</p>
                <SimpleInput
                  type="text"
                  name="totalPrice"
                  placeholder="Product Price"
                  value={totalPrice}
                  onChange={handleChange}
                  mask={maskMoney}
                />
              </div>
              <div className="form__row-item--half">
                <div className="simple-input__label">Yield in Grams</div>
                <FormsySimpleInput
                  type="number"
                  name="grams"
                  placeholder="Yield in Grams"
                  value={grams}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form__row form__row--spacer">
              <div className="form__row-item--third">
                <p className="simple-input__label">Unit Price</p>
                <p className="p">{maskMoney(price)}</p>
              </div>
              <div className="form__row-item--no-flex">
                <p className="p label--spacer">per</p>
              </div>
              <div className="form__row-item--half">
                <p className="simple-input__label">Unit</p>
                <FormSelect
                  name="unit"
                  placeholder="Unit"
                  value={unit.id}
                  onChange={handleSelectChange}
                  options={unitOptions}
                  required
                />
              </div>
            </div>

            <div className="form__row">
              <div className="form__row-item--half">
                <div
                  className="btn btn--hollow-red-bright btn--full-width"
                  onClick={closeModal}
                >
                  Cancel
                </div>
              </div>
              <div className="form__row-item--half">
                <input
                  type="submit"
                  className="btn btn--solid-blue btn--full-width"
                  value="Save"
                />
              </div>
            </div>
          </Formsy>
        </div>
      </Modal>
    );
  }

  prepUnitOptions = units => {
    return units.map(({ id, name }) => ({ value: id, label: name }));
  };

  calcUnitPrice = (unit, totalPrice = 0, grams = 0) => {
    if (!('grams' in unit) || !('name' in unit) || !grams) return 0;
    if (unit.name === 'ea') return totalPrice;

    const unitPrice = (dollarsToCents(totalPrice) * unit.grams) / grams;

    return Math.round(unitPrice);
  };

  handleChange = e => {
    const { name, value } = e.target;
    const state = {
      ...this.state,
      [name]: value
    };
    state.price = this.calcUnitPrice(state.unit, state.totalPrice, state.grams);

    this.setState(state);
  };

  handleSelectChange = val => {
    const { availableUnits, totalPrice, grams } = this.state;
    const unit =
      val && 'value' in val
        ? availableUnits.find(unit => unit.id === val.value)
        : {};
    const price = this.calcUnitPrice(unit, totalPrice, grams);
    this.setState({ unit, price });
  };

  handleSubmit = () => {
    const product = {
      product_unit: { ...this.state.unit },
      unit_price_cents: dollarsToCents(this.state.price),
      paid_price_cents: dollarsToCents(this.state.totalPrice),
      yield_grams: this.state.grams || 0
    };
    this.props.updateProduct(product);
  };

  deriveState() {
    return {
      totalPrice: maskMoney(this.props.product.paid_price_cents || 0),
      price: maskMoney(this.props.product.unit_price_cents || 0),
      unit: { ...this.props.product.product_unit } || {},
      grams: this.props.product.yield_grams || 0
    };
  }

  componentDidMount() {
    // initialize state from props
    const state = this.deriveState();
    this.setState(state);

    menuAPI
      .getProductUnits()
      .then(({ product_units }) =>
        this.setState({
          availableUnits: product_units,
          unitOptions: this.prepUnitOptions(product_units)
        })
      )
      .catch(error => console.log('Error:', error));
  }

  componentDidUpdate(prevProps) {
    // update state from props
    if (this.props.product !== prevProps.product) {
      const state = this.deriveState();
      this.setState(state);
    }
  }
}

export default ProductPricingModal;



// WEBPACK FOOTER //
// ./src/components/product/ProductPricingModal.js